/* eslint-disable import/prefer-default-export */
// @flow
export { default as withTargetedClickThrough } from './withTargetedClickThrough';
